import { useMemo } from "react";
import { BiSolidPin } from "react-icons/bi";
import { FaLocationDot } from "react-icons/fa6";
import { RiArrowTurnBackFill } from "react-icons/ri";
import PropTypes from "prop-types";

const ViaList = ({ dest1, dest2, viaList, lastUTurn, diversions }) => {
  const iconDict = {
    place: <BiSolidPin className="w-4 h-4 md:w-5 md:h-5" />,
    terminal: <FaLocationDot className="w-4 h-4 md:w-5 md:h-5" />,
    uTurn: <RiArrowTurnBackFill className="w-4 h-4 md:w-5 md:h-5" />,
  };

  let newList = useMemo(() => {
    return [
      {
        title: dest1,
        type: "terminal",
      },
      ...(viaList?.map((via) => ({
        title: via,
        type: via.includes("U-turn") ? "uTurn" : "place",
      })) ?? []),
      {
        title: dest2,
        type: "terminal",
      },
      ...(lastUTurn
        ? [
            {
              title: lastUTurn,
              type: "uTurn",
            },
          ]
        : []),
    ];
  }, [dest1, dest2, viaList, lastUTurn]);

  return (
    <>
      <ul className={`space-y-8 md:space-y-12 py-4`}>
        {newList.map((step, idx) => (
          <li key={idx} className="flex gap-4 md:gap-9">
            <div
              className={`p-1.5 md:p-3.5 w-7 h-7 md:w-12 md:h-12 bg-rose-700 text-accent-back text-sm rounded-full`}
            >
              {iconDict[step.type]}
            </div>

            <div
              className={`text-lg md:text-2xl md:pt-2 ${step.type == "terminal" ? "font-semibold" : ""}`}
            >
              {step.title}
            </div>
          </li>
        ))}
      </ul>

      {diversions && (
        <div className="pt-4">
          <h2 className="text-rose-800 text-[20px] font-semibold my-2">
            Diversions and Shuttles
          </h2>

          <ul className="px-8 text-[20px]">
            {diversions?.split(";").map((dv, idx) => (
              <li
                className="list-disc py-1 text-lg"
                key={`div_${idx}`}
              >{`${dv}.`}</li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

ViaList.propTypes = {
  dest1: PropTypes.string,
  dest2: PropTypes.string,
  viaList: PropTypes.array,
  lastUTurn: PropTypes.string,
  diversions: PropTypes.string,
};

export default ViaList;
